export const CALL_TEXT = 'Call';
export const POST_TEXT = 'Post';
export const EMAIL_TEXT = 'Email';
export const CLAIM_TEXT = 'Claim online';
export const EMERGENCY_TEXT = '24 Hour Emergency Assistance';
